export const CONFIG = {
  APP_ENV: process.env.REACT_APP_ENV,
  isDevelopment: process.env.REACT_APP_ENV === 'dev',
  isProduction: process.env.REACT_APP_ENV === 'prod',
  AUTH_API_URL: process.env.REACT_APP_AUTH_API_URL || '',
  TALENT_API_URL: process.env.REACT_APP_TALENT_API_URL || '',
  CASTING_API_URL: process.env.REACT_APP_CASTING_API_URL || '',
  AGENCY_API_URL: process.env.REACT_APP_AGENCY_API_URL || '',
  AGENCY_APP_URL: process.env.REACT_APP_AGENCY_APP_URL || '',
  CASTING_APP_URL: process.env.REACT_APP_CASTING_APP_URL || '',
  UPLOAD_API_URL: process.env.REACT_APP_UPLOAD_API_URL || '',
  GRAPHQL_API_URL: process.env.REACT_APP_GRAPHQL_API_URL || '',
  // APP_IMAGE_URL: process.env.REACT_APP_IMAGE_URL,
  GOOGLE_APP_ID: process.env.REACT_APP_GOOGLE_APP_ID || '',
  FACEBOOK_APP_ID: process.env.REACT_APP_FB_APP_ID || '',
  CASTING_APP: process.env.REACT_APP_CASTING_APP_URL || '',
  ABSTRACT_API_URL: process.env.REACT_APP_ABSTRACT_API_URL || '',
  ABSTRACT_API_KEY: process.env.REACT_APP_ABSTRACT_API_KEY || '',
  COUNTRY_STATE_API_URL: process.env.REACT_APP_COUNTRY_STATE_API_URL || '',
  COUNTRY_STATE_API_KEY: process.env.REACT_APP_COUNTRY_STATE_API_KEY || '',
  // GOOGLE_GEOCODER_API_URL: process.env.REACT_APP_GOOGLE_GEOCODER_API_URL || '',
  // GOOGLE_GEOCODER_API_KEY: process.env.REACT_APP_GOOGLE_GEOCODER_API_KEY || '',
  // GEONAME_USERNAME: process.env.REACT_APP_GEONAME_USERNAME || '',
  AUTH_SERVICE_API_KEY: process.env.REACT_APP_AUTH_SERVICE_API_KEY || '',
  S3_URL: process.env.REACT_APP_S3_URL || '',
  TALENT_APP_URL: process.env.REACT_APP_TALENT_APP_URL || '',
  JOBS_APP_URL: process.env.REACT_APP_JOBS_APP_URL || '',
};
